// extracted by mini-css-extract-plugin
export default {"previewBox":"imagePreview_previewBox__JABbp","imageWrapper":"imagePreview_imageWrapper__26wBs","image":"imagePreview_image__FAyt1","imageLabel":"imagePreview_imageLabel__g+1zw"};